import { render, staticRenderFns } from "./IbSwitch.vue?vue&type=template&id=eb199550"
import script from "./IbSwitch.vue?vue&type=script&lang=js"
export * from "./IbSwitch.vue?vue&type=script&lang=js"
import style0 from "./IbSwitch.vue?vue&type=style&index=0&id=eb199550&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports